'use strict';

export default class AppointmentTime {
  static of(data) {
    return new AppointmentTime(
      data.appointmentId,
      data.slotId,
      data.dateStart,
      data.dateEnd,
      data.original,
      data.selected,
      data.visitType,
      data.location,
      data.modify
    );
  }

  constructor(
    id,
    slot,
    dateStart,
    dateEnd,
    original,
    selected,
    visitType,
    location,
    modify
  ) {
    this.id = id;
    this.slot = slot;
    this.dateStart = dateStart;
    this.dateEnd = dateEnd;
    this.original = original;
    this.selected = selected;
    this.visitType = visitType;
    this.location = location;
    this.modify = modify;
  }

  toJSON() {
    return {
      id: this.id,
      slot: this.slot,
      dateStart: this.dateStart,
      dateEnd: this.dateEnd,
      original: this.original,
      selected: this.selected,
      visitType: this.visitType,
      location: this.location,
    };
  }

  get id() {
    return this._id;
  }

  set id(id) {
    this._id = id;
  }

  get slot() {
    return this._slot;
  }

  set slot(slot) {
    this._slot = slot;
  }

  get dateStart() {
    return this._dateStart;
  }

  set dateStart(dateStart) {
    this._dateStart = dateStart;
  }

  get dateEnd() {
    return this._dateEnd;
  }

  set dateEnd(dateEnd) {
    this._dateEnd = dateEnd;
  }

  get original() {
    return this._original;
  }

  set original(original) {
    this._original = original;
  }

  get selected() {
    return this._selected;
  }

  set selected(selected) {
    this._selected = selected;
  }

  get visitType() {
    return this._visitType;
  }

  set visitType(visitType) {
    this._visitType = visitType;
  }

  get location() {
    return this._location;
  }

  set location(location) {
    this._location = location;
  }
}
